/*
    This solution was taken from: https://levelup.gitconnected.com/how-to-create-custom-html-markers-on-google-maps-9ff21be90e4b

    Some variations were made to address our specific use case.
*/

class GoogleMapBrandMarker extends google.maps.OverlayView {
    constructor({ ...args }) {
        super();

        this.position = new google.maps.LatLng(args.latlng.lat, args.latlng.lng);
        this.setMap(args.map);
        this.imgSrc = args.imgSrc;
        this.animation = args.animation;
        this.markerId = args.markerId;
        this.markerSize = args.markerSize
    }


    getHtml() {
        const image = document.createElement('img');
        image.id = `${this.markerId}-inner`;
        image.src = this.imgSrc;
        image.style = "max-width: 100%; border-radius: 50%;"

        return image;
    }

    getId() {
        return this.markerId;
    }

    draw() {
        if (!this.div) {
            this.div = document.createElement('div');
            this.div.id = this.markerId;
            this.div.appendChild(this.getHtml());
            this.div.style =
                `position: absolute;
                display: flex;
                align-items: center;
                width: ${this.markerSize === "SMALL" ? "25px" : "43px"}; 
                height: ${this.markerSize === "SMALL" ? "25px" : "43px"};
                background-color: #e7e8ed;                                                
                border-radius: 50%;
                border: 1px solid #c4c4c4;
                animation: bounceInDown;`;

            this.div.addEventListener('click', event => {
                google.maps.event.trigger(this, 'click');
            });

            this.div.addEventListener('mouseover', event => {
                google.maps.event.trigger(this, 'mouseover');
            });

            this.div.addEventListener('mouseout', event => {
                google.maps.event.trigger(this, 'mouseout');
            });

            const panes = this.getPanes();
            panes.overlayImage.appendChild(this.div);
        }

        const point = this.getProjection().fromLatLngToDivPixel(this.position);

        if (point) {
            this.div.style.left = `${point.x}px`;
            this.div.style.top = `${point.y}px`
        }
    }

    getMarkerSizeDimensions(imgSrc) {
        const minDimensions = { width: 43, height: 43 };
        const dimensions = { width: 0, height: 0 };
        const image = new Image();
        image.src = imgSrc;

        dimensions.width = image.width < minDimensions.width
            ? `${minDimensions.width}px`
            : `${image.width}px`;
        dimensions.height = image.height < minDimensions.height
            ? `${minDimensions.height}px`
            : `${image.height}px`;

        return dimensions;
    }

    remove() {
        if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    }

    getPosition() {
        return this.position;
    }

    getDraggable() {
        return false;
    }

    setAnimation(animation) {
        //For our specific case, setting the animation will always result in bounce or null.

        this.animation = animation;
        const element = document.getElementById(this.markerId);

        if (element) {
            if (animation) {
                element.style.animation = "bounce 1.2s infinite";
            } else {
                element.style.animation = null;
            }
        }
    }

    getAnimation() {
        return this.animation;
    }

    setIcon(src) {
        this.div.children[0].src = src
    }
}

export const createBrandMapMarker = ({ ...args }) => {
    return new GoogleMapBrandMarker({ ...args })
};
